export enum EventType {
    EASTER_2025 = 'easter_2025',
}
